module.exports = __webpack_public_path__ + "img/co2_outline_black.14ffe2c8.svg";